import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApiLogout } from "../../hooks/api/useApiLogout";
import routes from "../../router/routes";

const Logout = () => {
  const { logout } = useApiLogout();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      await logout();      // サーバにloginHistoryIdを送り、logout_at更新
      window.location.replace(`${window.location.origin}/login`);
    })();
  }, [logout, navigate]);

  return null; // 画面は何も表示しない(必要ならスピナー等を表示)
};

export default Logout;
